import controller from './timeout-warning-controller';

const TimeoutWarningComponent = {
    bindings: {
        showModal: '<',
    },
    controller
};

export default TimeoutWarningComponent;



// WEBPACK FOOTER //
// ./app/common/timeout-warning/timeout-warning-component.js